import { render, staticRenderFns } from "./legend.vue?vue&type=template&id=ddddbd0a&scoped=true&"
import script from "./legend.vue?vue&type=script&lang=ts&"
export * from "./legend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddddbd0a",
  null
  
)

export default component.exports